import { useData } from "data/data-provider";

const WhyChooseUS = () => {
  const { whyUs } = useData();

  return (
    <div
      className={`grid ${
        whyUs?.keypoints?.length === 0
          ? "grid-cols-1"
          : "grid-cols-1 lg:grid-cols-2"
      } py-12 gap-12 items-center `}
    >
   
      {(whyUs?.heading || whyUs?.description) && (
        <div>
          <h2
            className={`leading-none text-2xl text-text-color  font-semibold mb-4 ${
              whyUs?.keypoints?.length === 0
                ? "text-center"
                : "sm:text-start text-center"
            }`}
          >
            <span className="text-text-color" dangerouslySetInnerHTML={{ __html: whyUs?.heading }} />
          </h2>
          <p
            className={`text-secondary-text-color text-2xl mb-8 ${
              whyUs?.keypoints?.length === 0
                ? "text-center"
                : "sm:text-start text-center"
            }`}
          >
            <span className="text-secondary-text-color" dangerouslySetInnerHTML={{ __html: whyUs?.description }} />
          </p>
        </div>
      )}

      {/* Right Section */}
      <div className="grid grid-cols-2 gap-8">
        {whyUs?.keypoints?.map((feature: any, index: any) => (
          <div
            key={index}
            className="flex flex-col items-center sm:items-start text-left"
          >
            <img
              className="text-blue-500 text-4xl mb-2 max-w-14 max-h-14 rounded-md"
              src={feature.image_url}
              alt={feature.image_url}
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).style.display = "none";
              }}
            />
            <span
              className="leading-none text-text-color text-2xl font-semibold mb-1"
              dangerouslySetInnerHTML={{ __html: feature.heading }}
            />
            <p
              className="text-secondary-text-color text-2xl leading-none"
              dangerouslySetInnerHTML={{ __html: feature.description }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyChooseUS;
